import Vue from 'vue'
import Router from 'vue-router'







Vue.use(Router)
const router= new Router({
  routes: [
    {path: '/', redirect: '/investment'},
    {path: '/home',name: '/home',component: () => import ('@/components/index')}, //首页
    {path: '/news',name: 'tabsNews',component: () => import ('@/components/tabs/tabsNews')}, //新闻资讯
    {path: '/policy',name: 'tabsPolicy',component: () => import ('@/components/tabs/tabsPolicy')}, //政策法规
    {path: '/investment',name: 'investment',component: () => import ('@/components/worker')}, //办事大厅
    {path: '/announcement',name: 'announcement',component: () => import ('@/components/tabs/tabsAnnouncement')}, //公示信息
    {path: '/case',name: 'case',component: () => import ('@/components/tabs/tabsCase')}, //公示信息
    {path: '/recruit',name: 'tabsRecruit',component: () => import ('@/components/recruit/tabsRecruit')}, //供求信息
    {path: '/download',name: 'download',component: () => import ('@/components/tabs/tabsdownload')}, //下载专区
    {path: '/credit',name: 'credit',component: () => import ('@/components/tabs/tabsCredit')}, //信用评价
    {path: '/credit2',name: 'credit',component: () => import ('@/components/tabs/tabsCredit2')}, //信用评价2
    {path: '/info',name: 'info',component: () => import ('@/components/tabs/tabsNewsInfo')}, //新闻详情
    {path: '/enterprise',name: 'enterprise',component: () => import ('@/components/enterprise')},
    {path: '/login',name: 'login',component: () => import ('@/components/login')},
    {path: '/my',name: 'my',component: () => import ('@/components/mine/my')},
    {path: '/forgetPassword',name: 'forgetPassword',component: () => import ('@/components/forgetPassword')},
    {path: '/mailverify',name: 'mailverify',component: () => import ('@/components/mailverify')},
    {path: '/submit',name: 'workerSubmit',component: () => import ('@/components/workerSubmit')},
    {path: '/ad',name: 'ad',component: () => import ('@/components/ad/ad')},
  ]
})
// investment

// console.log(user)
router.beforeEach((to, from, next) => {
  let  user = sessionStorage.getItem('user')
  if(from.path=='login'&&to.path=='home'){
    router.go(0)
  }
  if((to.path == '/my') && (user==null)){
    next({
      path: '/login'
    })
    // router.push("/login");
  }else if((to.path == '/recruit' && user==null)){
    next({
      path: '/login'
    })
    // router.push("/login");
  }else{
    // alert('next')
    next()
    // router.go(0)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js